import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/globals.css';
import { ensureArcadiaCsrf } from '@/lib/api-fetch';
import { installChunkErrorRecovery } from '@/lib/installChunkErrorRecovery';

installChunkErrorRecovery();
void ensureArcadiaCsrf();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
